/* eslint-disable @typescript-eslint/no-explicit-any */
import { IAppAction } from "../appAction";
import { IOperation } from "../../services/RedGifsService";
import { IUserSettings } from "../../services/types";

export const userActions = {
  FETCH_CURRENT_USER: "FETCH_CURRENT_USER",
  FETCH_CURRENT_USER_SUCCESS: "FETCH_CURRENT_USER_SUCCESS",
  FETCH_CURRENT_USER_ERROR: "FETCH_CURRENT_USER_ERROR",

  FETCH_CURRENT_USER_TAGS: "FETCH_CURRENT_USER_TAGS",
  FETCH_CURRENT_USER_TAGS_SUCCESS: "FETCH_CURRENT_USER_TAGS_SUCCESS",
  FETCH_CURRENT_USER_TAGS_ERROR: "FETCH_CURRENT_USER_TAGS_ERROR",

  FETCH_MY_NICHES: "FETCH_MY_NICHES",
  FETCH_MY_NICHES_SUCCESS: "FETCH_MY_NICHES_SUCCESS",
  FETCH_MY_NICHES_ERROR: "FETCH_MY_NICHES_ERROR",

  FETCH_LIKED_GIFS: "FETCH_LIKED_GIFS",
  FETCH_LIKED_GIFS_SUCCESS: "FETCH_LIKED_GIFS_SUCCESS",
  FETCH_LIKED_GIFS_ERROR: "FETCH_LIKED_GIFS_ERROR",

  UPDATE_USER_PROFILE: "UPDATE_USER_PROFILE",
  UPDATE_USER_PROFILE_SUCCESS: "UPDATE_USER_PROFILE_SUCCESS",
  UPDATE_USER_PROFILE_ERROR: "UPDATE_USER_PROFILE_ERROR",

  UPDATE_USER_SETTINGS: "UPDATE_USER_SETTINGS",
  UPDATE_USER_SETTINGS_SUCCESS: "UPDATE_USER_SETTINGS_SUCCESS",
  UPDATE_USER_SETTINGS_ERROR: "UPDATE_USER_SETTINGS_ERROR",

  DELETE_MY_ACCOUNT: "DELETE_MY_ACCOUNT",

  UPDATE_PROFILE_PHOTO: "UPDATE_PROFILE_PHOTO"
};

export const fetchCurrentUser = (): IAppAction => ({
  type: userActions.FETCH_CURRENT_USER
});

export const fetchCurrentUserSuccess = (payload: any): IAppAction => ({
  type: userActions.FETCH_CURRENT_USER_SUCCESS,
  payload
});

export const fetchCurrentUserError = (error: Error): IAppAction => ({
  type: userActions.FETCH_CURRENT_USER_ERROR,
  payload: error
});

export const updateUserProfile = (payload: IOperation[]): IAppAction => ({
  type: userActions.UPDATE_USER_PROFILE,
  payload
});

export const updateUserProfileSuccess = (): IAppAction => ({
  type: userActions.UPDATE_USER_PROFILE_SUCCESS
});

export const updateUserProfileError = (payload: Error): IAppAction => ({
  type: userActions.UPDATE_USER_PROFILE_ERROR,
  payload
});

export const updateUserSettings = (payload: IUserSettings): IAppAction => ({
  type: userActions.UPDATE_USER_SETTINGS,
  payload,
});

export const updateUserSettingsSuccess = (payload: IUserSettings): IAppAction => ({
  type: userActions.UPDATE_USER_SETTINGS_SUCCESS,
  payload,
});

export const updateUserSettingsError = (payload: Error): IAppAction => ({
  type: userActions.UPDATE_USER_SETTINGS_ERROR,
  payload,
});

export const updateProfilePhoto = (payload: any): IAppAction => ({
  type: userActions.UPDATE_PROFILE_PHOTO,
  payload
});

export const fetchMyNiches = (): IAppAction => ({
  type: userActions.FETCH_MY_NICHES
});

export const fetchMyNichesSuccess = (payload: any): IAppAction => ({
  type: userActions.FETCH_MY_NICHES_SUCCESS,
  payload
});

export const fetchMyNichesError = (error: Error): IAppAction => ({
  type: userActions.FETCH_MY_NICHES_ERROR,
  payload: error
});
